import { PATH_DELIMITER, JOIN_US_PHASE2 } from '../../../constant/Constant';
import { createAction, handleActions } from 'redux-actions';
import { call, put, takeEvery } from '@redux-saga/core/effects';
import { request } from '../../ApiModule';

const ACTION_JOIN_US_PHASE2 = JOIN_US_PHASE2 + PATH_DELIMITER + 'ACTION_JOIN_US_PHASE2';
const HANDLE_AUTH_USER = JOIN_US_PHASE2 + PATH_DELIMITER + 'HANDLE_AUTH_USER';

export const actionJoinUsPhase2 = createAction(ACTION_JOIN_US_PHASE2);

export function* joinUsPhase2Sagas() {
    yield takeEvery(ACTION_JOIN_US_PHASE2, joinUsPhase2Saga);
}

function* joinUsPhase2Saga({ payload: { data, callback } }) {
    const result = yield call(request, {
        method: 'post',
        url: '/api/email/sign-up',
        data,
        callback,
    });

    if (result != undefined) {
        yield put({
            type: HANDLE_AUTH_USER,
            payload: {
                result,
            },
        });
    }
}

const initialState = {
    result: false,
};

const module = handleActions(
    {
        [HANDLE_AUTH_USER]: (state, { payload: result }) => ({ ...state, ...result }),
    },
    initialState,
);

export default module;
